
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/[league]/[year]/[teamName]/[gameReference]",
      function () {
        return require("private-next-pages/game/[league]/[year]/[teamName]/[gameReference]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/[league]/[year]/[teamName]/[gameReference]"])
      });
    }
  